//
//
//
//

export default {
  data() {
    return {
      timer: null,
  		isTop: true,
  		show: false,
  		clientHeight: null
    }
  },

	methods: {
    go () {
      this.$router.push('/complaint')
    }
	}
}



// WEBPACK FOOTER //
// ./src/components/Complaint.vue